<template>
  <footer class="custom-footer">
    <div class="footer-container px-3 px-md-5 py-1">
      <!-- Left: Delivery Partner Assurance -->
      <div class="footer-item mb-50 mb-md-0">
        <svg
          class="footer-icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#4b5563"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
        <span class="footer-text">Your trusted delivery partner</span>
      </div>
    </div>
  </footer>
</template>

<script>
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const trackingRepository = RepositoryFactory.get('tracking')

export default {
  mixins: [ErrorMessage],
  data() {
    return {
      business: {},
      loading: false,
    }
  },
  mounted() {
    this.getBusinessInfo()
  },
  methods: {
    async getBusinessInfo() {
      try {
        this.loading = true
        const cachedSettings = localStorage.getItem('businessSettings')
        if (cachedSettings) {
          this.business = JSON.parse(cachedSettings)
        } else {
          const response = await trackingRepository.getBusinessInfo()
          this.business = response.data.data
          localStorage.setItem('businessSettings', JSON.stringify(this.business))
        }
      } catch (e) {
        if (typeof this.convertAndNotifyError === 'function') {
          this.convertAndNotifyError(e)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
/* Force footer to be full-width, flush with zero margin */
.custom-footer {
  width: 100% !important;
  margin: 0 !important;
  background-color: #ffffff !important;
  border-top: 1px solid #edf0f2 !important;
  border-radius: 0 !important;
  position: relative;
  z-index: 10;
}

.footer-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.footer-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-icon {
  flex-shrink: 0;
  margin-right: 5px;
}

.footer-text {
  font-size: 0.9rem;
  font-weight: 500;
  color: #4b5563;
}

.footer-link {
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: #a30014;
  text-decoration: underline;
}
</style>
